/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectDailyTask } from '../../models/create-project-daily-task';
import { CreateProjectDailyTaskReportCommandResult } from '../../models/create-project-daily-task-report-command-result';
import { DirectLaborVm } from '../../models/direct-labor-vm';
import { InDirectLaborVm } from '../../models/in-direct-labor-vm';
import { ReportEquipmentVm } from '../../models/report-equipment-vm';
import { ReportManpowerVm } from '../../models/report-manpower-vm';
import { RiskIndexVm } from '../../models/risk-index-vm';

export interface ApiProjectDailyTaskReportsCreateProjectDailyTaskReportPost$Params {
      body?: {
'ProjectId': string;
'Materials': string;
'ContractorNotes'?: string;
'Resources'?: string;
'ConsultingNotes'?: string;
'RiskIndices'?: Array<RiskIndexVm>;
'ProjectItemsIDs'?: Array<string>;
'ProjectDailyTasks'?: Array<CreateProjectDailyTask>;
'ProjectDailyExpectedTasks'?: Array<string>;
'Attachments'?: Array<Blob>;
'Manpowers'?: Array<ReportManpowerVm>;
'Equipments'?: Array<ReportEquipmentVm>;
'DirectLabors'?: Array<DirectLaborVm>;
'InDirectLabors'?: Array<InDirectLaborVm>;
}
}

export function apiProjectDailyTaskReportsCreateProjectDailyTaskReportPost(http: HttpClient, rootUrl: string, params?: ApiProjectDailyTaskReportsCreateProjectDailyTaskReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectDailyTaskReportCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectDailyTaskReportsCreateProjectDailyTaskReportPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectDailyTaskReportCommandResult>;
    })
  );
}

apiProjectDailyTaskReportsCreateProjectDailyTaskReportPost.PATH = '/api/ProjectDailyTaskReports/CreateProjectDailyTaskReport';
